var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DsaElement } from "@/components";
import { useClassified, useHardFacts } from "@/contexts/classified";
import { useCustomerAction, useIsTablet, useMortgage, useTrackingProductClick, } from "@/hooks";
import { useBrandContext } from "@/shared/contexts";
import { FINANCIAL_LINK_PARTNER, PARTNER_NAME } from "@/shared/types";
import { Box } from "@gemini/core";
import { CalculatorIcon, MoneyCheckDollarPenIcon } from "@gemini/icons";
import { PriceLink } from "./PriceLink";
import { brandConfiguration } from "@/brands/config";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { InteractionEnum, InteractionValueEnum } from "@/types";
export const MortgagePriceLink = ({ variant = "default", }) => {
    var _a, _b, _c, _d, _e;
    const mortgage = useMortgage();
    const { customerActionLeadInteraction } = useCustomerAction();
    const isPreviewMode = useIsPreviewMode();
    const { financialLink } = ((_a = useHardFacts()) === null || _a === void 0 ? void 0 : _a.price) || {};
    const partnerName = PARTNER_NAME.SCHUFA;
    const isTablet = useIsTablet();
    const partner = ((_c = (_b = useBrandContext()) === null || _b === void 0 ? void 0 : _b.partnerService) !== null && _c !== void 0 ? _c : []).find((service) => service.name === partnerName);
    const handleTrackingProductClick = useTrackingProductClick(partnerName);
    const partnerAd = (_e = (_d = useClassified()) === null || _d === void 0 ? void 0 : _d.sections) === null || _e === void 0 ? void 0 : _e.partnerAd;
    const priceLabel = mortgage === null || mortgage === void 0 ? void 0 : mortgage.priceLinkLabel;
    if (!priceLabel)
        return null;
    const isBuyPrice = mortgage === null || mortgage === void 0 ? void 0 : mortgage.showMonthlyRateLabel;
    const isRentPrice = !isBuyPrice && (mortgage === null || mortgage === void 0 ? void 0 : mortgage.showRentLabel);
    const { priceLinkInfoIcon } = brandConfiguration;
    if (!mortgage.hasRentFinancialLink &&
        isRentPrice &&
        (!partner || !(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd)))
        return null;
    const handleLinkClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isPreviewMode)
            return;
        if (isBuyPrice)
            handlePartnerLinkClickBuy();
        if (isRentPrice)
            handlePartnerLinkClickRent();
    });
    const addDeviceTracking = (partnerName) => {
        if (partnerName !== FINANCIAL_LINK_PARTNER.CA &&
            partnerName !== FINANCIAL_LINK_PARTNER.CM)
            return "";
        const isCA = partnerName === FINANCIAL_LINK_PARTNER.CA;
        const deviceType = isTablet ? "Mobile" : "Desktop";
        return isCA
            ? `&at_libre=${deviceType}`
            : `&utm_medium=${deviceType.toLowerCase()}`;
    };
    const handlePartnerLinkClickBuy = () => __awaiter(void 0, void 0, void 0, function* () {
        // eslint-disable-next-line no-restricted-globals
        window.open(
        // @ts-ignore
        `${financialLink === null || financialLink === void 0 ? void 0 : financialLink.href}${addDeviceTracking(financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName)}`, "_blank");
        customerActionLeadInteraction(InteractionEnum.CLICK, InteractionValueEnum.FINANCING);
    });
    const handlePartnerLinkClickRent = () => __awaiter(void 0, void 0, void 0, function* () {
        if (mortgage.hasRentFinancialLink) {
            // eslint-disable-next-line no-restricted-globals
            window.open(`${financialLink === null || financialLink === void 0 ? void 0 : financialLink.href}`);
        }
        if (!(partnerAd === null || partnerAd === void 0 ? void 0 : partnerAd.showPartnerAd))
            return null;
        handleTrackingProductClick();
        yield customerActionLeadInteraction(InteractionEnum.CLICK, InteractionValueEnum.SCHUFA);
        if (partner === null || partner === void 0 ? void 0 : partner.withObfuscation) {
            // eslint-disable-next-line no-restricted-globals
            window.open(partner.url, "_blank");
        }
    });
    const getButtonStyleBackgroundColor = () => {
        if (variant !== "colored" || mortgage.hasRentFinancialLink)
            return;
        if (isBuyPrice) {
            return "color.surface.score.diamond";
        }
        return "color.surface.active.default";
    };
    const boxStyleProps = variant === "buttonStyled"
        ? {
            borderStyle: "solid",
            borderWidth: "borderWidth.1",
            borderRadius: "radius.rounded",
            height: "fit-content",
        }
        : {
            borderRadius: "radius.8",
        };
    return variant === "buttonStyled" || variant === "colored" ? (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: getButtonStyleBackgroundColor(), paddingHorizontal: "spacing.12", paddingVertical: "spacing.8" }, boxStyleProps, { children: [!mortgage.hasRentFinancialLink &&
                (isBuyPrice ? (_jsx(CalculatorIcon, { marginRight: "spacing.8" })) : (_jsx(MoneyCheckDollarPenIcon, { marginRight: "spacing.8" }))), _jsx(PriceLink, { handleLinkClick: handleLinkClick }), (isRentPrice ||
                (financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName) !== FINANCIAL_LINK_PARTNER.KFW) &&
                priceLinkInfoIcon && _jsx(DsaElement, {})] }))) : (_jsxs(Box, { as: "span", display: "flex", alignItems: "center", marginTop: "spacing.8", children: [_jsx(PriceLink, { handleLinkClick: handleLinkClick }), (isRentPrice ||
                (financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName) !== FINANCIAL_LINK_PARTNER.KFW) &&
                priceLinkInfoIcon && _jsx(DsaElement, {})] }));
};
